import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Information = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M7.90515222,1.78869258 C8.41335149,1.2628949 9.02809944,1 9.74941452,1 C10.4598006,1 11.0690841,1.2628949 11.5772834,1.78869258 C12.0854826,2.31449026 12.3395785,2.9505263 12.3395785,3.69681979 C12.3395785,4.44311327 12.0854826,5.07914931 11.5772834,5.604947 C11.0690841,6.13074468 10.4598006,6.39363958 9.74941452,6.39363958 C9.02809944,6.39363958 8.41335149,6.13074468 7.90515222,5.604947 C7.39695296,5.07914931 7.14285714,4.44311327 7.14285714,3.69681979 C7.14285714,2.9505263 7.39695296,2.31449026 7.90515222,1.78869258 Z M6,18.4388123 C6.59016689,18.3700951 6.99453443,18.2670208 7.21311475,18.1295864 C7.54098525,17.9234348 7.70491803,17.553131 7.70491803,17.0186638 L7.70491803,10.1240721 C7.70491803,9.65068692 7.59016508,9.32810266 7.36065574,9.15630965 C7.13114639,8.98451664 6.67759902,8.8566282 6,8.77264051 L6,8.2 L12.442623,8.2 L12.442623,17.1102863 C12.442623,17.6218477 12.5519115,17.9501583 12.7704918,18.095228 C12.9890721,18.2402977 13.3989041,18.3548246 14,18.4388123 L14,19 L6,19 L6,18.4388123 Z"
				id="information"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Information.propTypes = {
	color: PropTypes.string,
};

export default Information;
